<div class="agpr-targeting-notes">
    <agpr-tabs
        [class]="_entityType === entityTypes.CONTACT? 'agpr-targeting-notes-agpr-tabs':'agpr-targeting-notes-agpr-no-tabs'"
        [selectedTabIndex]="selectedTabIndex"
        (selectedTabIndexChange)="tabIndexChange($event)"
        [useContentContainer]="false"
        (tabChange)="tabChange($event)"
        [tabLineWidth]="5"
    >
        <agpr-tab
            [id]="tabIds.CONTACT"
            [heading]="'Discover.targeting.rhp.tabs.notes.contact'"
            [numberDescription]="contactUserNotes?.length.toString()">
        </agpr-tab>
        <agpr-tab
            [id]="tabIds.OUTLET"
            [heading]="'Discover.targeting.rhp.tabs.notes.outlet'"
            [numberDescription]="outletUserNotes?.length.toString()"
            [disabled]="!outletEntity?.id"
        >
        </agpr-tab>
    </agpr-tabs>

    @if (selectedTabIndex === 0){
        <agpr-user-notes
            [id]="selectedTabId + '_fullProfile_userNotes'"
            [userNotes]="contactUserNotes"
            [currentUser]="currentUser"
            (notesChanged)="modifyNotes($event)"
            [isNotesTab]="true"
        ></agpr-user-notes>
    }
    @if (selectedTabIndex === 1){
        <agpr-user-notes
            [id]="selectedTabId + '_fullProfile_outletNotes'"
            [userNotes]="outletUserNotes"
            [currentUser]="currentUser"
            (notesChanged)="modifyNotes($event)"
            [isNotesTab]="true"
            [readonly]="disableOutletAddNotes"
        ></agpr-user-notes>
    }
</div>